export const initialState = {
  isAdmin: null,
}

export const set = (state, payload) => payload
